<template lang="pug">
  .component-backoffice-reservation-hold-billing.row.column
    base-list(:component="component", :dataLoader="dataLoader", :search="search", ref="list")
</template>

<script type="text/babel">
  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
  import BaseList from './BaseList'

  export default {
    name: 'ReservationList',
    components: {
      BaseList,
    },
    data: function () {
      return {
        component: require('src/components/backoffice/Reservation.vue'),

        search: {
          flag: 'HOLD_BILLING',
        }
      }
    },
    methods: {

      dataLoader(callback, page, resultsPerPage, search) {
        if (search) {
          KeplerBackofficeSdk.reservations.list(page, resultsPerPage, search).all((data) => {
            callback(data)
          })
        }
      }
    }
  }
</script>

<style lang="sass" rel="stylesheet/sass">
  .component-backoffice-client-approval
    .activeIcon
      color: #64db6f
</style>



// WEBPACK FOOTER //
// ReservationsHoldBillingQueue.vue?48c9b7cf